export const CommonSections = {
    default: 'default',
} as const

export const PerthNowStickyNav = {
    ...CommonSections,
    'wa-news': 'wa-news',
    'celebrity-gossip': 'celebrity-gossip',
    'over-east': 'over-east',
    crime: 'crime',
    'best-eats': 'best-eats',
    'west-coast': 'west-coast',
    fremantle: 'fremantle',
    weather: 'weather',
    traffic: 'traffic',
    lotto: 'lotto',
} as const

export const PerthNowSections = {
    generic: 'generic',
    news: 'news',
    sport: 'sport',
    business: 'business',
    entertainment: 'entertainment',
    lifestyle: 'lifestyle',
    video: 'video',
    classifieds: 'classifieds',
    politics: 'politics',
    travel: 'travel',
    technology: 'technology',
    opinion: 'opinion',
    'shop-now': 'shop-now',
    'community-news': 'community-news',
    'local-news': 'local-news',
    'read-your-local-paper': 'read-your-local-paper',
    'top-stories': 'top-stories',
    food: 'food',
    ...CommonSections,
    ...PerthNowStickyNav,
} as const

export type PerthNowSections = typeof PerthNowSections

export type RoutablePerthNowSection = keyof Omit<
    PerthNowSections,
    'generic' | 'default'
>

export const SevenNewsSections = {
    ...CommonSections,
} as const

export type SevenNewsSections = typeof SevenNewsSections

export const TheWestRegionalSections = {
    'albany-advertiser': 'albany-advertiser',
    'great-southern-herald': 'great-southern-herald',
    'augusta-margaret-river-times': 'augusta-margaret-river-times',
    'busselton-dunsborough-times': 'busselton-dunsborough-times',
    'broome-advertiser': 'broome-advertiser',
    'the-kimberley-echo': 'the-kimberley-echo',
    'geraldton-guardian': 'geraldton-guardian',
    'midwest-times': 'midwest-times',
    'bunbury-herald': 'bunbury-herald',
    'harvey-waroona-reporter': 'harvey-waroona-reporter',
    'manjimup-bridgetown-times': 'manjimup-bridgetown-times',
    'south-western-times': 'south-western-times',
    'kalgoorlie-miner': 'kalgoorlie-miner',
    'narrogin-observer': 'narrogin-observer',
    'north-west-telegraph': 'north-west-telegraph',
    'pilbara-news': 'pilbara-news',
    'sound-telegraph': 'sound-telegraph',
    countryman: 'countryman',
} as const

export const TheWestSections = {
    ...CommonSections,
    ...TheWestRegionalSections,
    genwest: 'genwest',
} as const

export type TheWestSections = typeof TheWestSections

export const TheNightlySections = {
    ...CommonSections,
    australia: 'australia',
    opinion: 'opinion',
    world: 'world',
    politics: 'politics',
    business: 'business',
    sport: 'sport',
    society: 'society',
    culture: 'culture',
    lifestyle: 'lifestyle',
    travel: 'travel',
    from: 'from',
    podcasts: 'podcasts',
    video: 'video',
    'best-australian-yarn': 'best-australian-yarn',
    'us-politics': 'us-politics',
    on: 'on',
} as const

export type TheNightlySections = typeof TheNightlySections

export type RoutableNightlySection = keyof Omit<TheNightlySections, 'default'>
